import React from 'react';

export default () => (
  <span>
    An abbreviated hierarchy is displayed below. Click for more information.
  </span>
);
